export default __webpack_public_path__ + "static/media/indicators.5294077a.svg";